import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from 'redux/slices/authSlice';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { LeftArrowIcon } from 'assets/icons/AntDeisgn_icons/iconStyle';
import { Checkbox, Form, Input, Select, message } from 'antd';
import { BackButton, StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { createDomain, getDomainData, updateDomain } from 'redux/slices/domainSlice';
import {
  CreateContendwrap,
  CreateFormwrap,
  CreateStyleDiv,
  Createwrap,
} from 'component/create_ou_component/create_childOu_components/style';
import { CheckboxWrap } from './style';
import { getDropDownGroupData, setGroupSelectedItems } from 'redux/slices/getOuGroups';
import { FormHeader, FormItem, FormSubmitButtonConatainer, RowWrapper } from 'component/form_component/style';
import { resetTreeState } from 'redux/slices/treedata';
import { resetOuTreeState } from 'redux/slices/ouAdminTree';
import { resetDomainState } from 'redux/slices/selectedNodeSlice';
import { FigCaption } from 'pages/license/style';
import { setSelectedItems } from 'redux/slices/userSlice';
import { InputPatternRule, InputPatternRuleDomainAdminDn } from 'utils/input_pattern';

function CreateDomain() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [domainCreated, setDomainCreated] = useState(false);
  const dropDownGroupData = useSelector((state) => state.getOuGroupData.dropDownData);
  const [submitButtonText, setSubmitButtonText] = useState('Connect');
  const [passwordMatch, setPasswordMatch] = useState(false);
  const [newDomainId, setNewDomainId] = useState(null);
  const { licenseDetails } = useSelector((state) => state.licenseSlice);
  const { domainFromApi } = useSelector((state) => state.domainData);

  // Custom validator to check if the passwords match
  const validatePasswordMatch = async (_, value) => {
    const newPassword = form.getFieldValue('password');
    if (newPassword && value === newPassword) {
      setPasswordMatch(true);
      return Promise.resolve();
    } else {
      setPasswordMatch(false);
      throw new Error('Passwords do not match');
    }
  };
  useEffect(() => {
    dispatch(getDomainData());
  }, []);
  useEffect(() => {
    if (parseInt(licenseDetails?.tierInfo) <= domainFromApi.length) {
      navigate('/adminpage');
    }
  }, [domainFromApi]);
  const handleUpdateDomain = async (values) => {
    values.domainName = values.domainName.trim();
    values.fqdn = values.fqdn.trim();
    values.username = values.username.trim();
    if (!checked) {
      values.superAdmin = '';
    }
    setLoading(true);
    try {
      const value = { id: newDomainId, values };
      const sweetAlert = await dispatch(updateDomain(value));

      if (sweetAlert.payload && sweetAlert.payload.status === 200 && values.isPrimaryDomain === true) {
        await SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'success', buttonColor: 'green' });
        if (values.isPrimaryDomain === true) {
          await SweetSweetAlert({
            icon: 'info',
            text: 'You will be logged out.!!',
            buttonColor: 'blue',
          });
          await dispatch(logout());
          dispatch(setSelectedItems([]));
          dispatch(setGroupSelectedItems([]));
          dispatch(resetTreeState());
          dispatch(resetOuTreeState());
          dispatch(resetDomainState());
          await navigate('/login');
        } else {
          await navigate('/adminpage');
        }
      } else if (sweetAlert.payload && sweetAlert.payload.status === 200) {
        if (
          sweetAlert.payload.data === 'Domain name is already in use.' ||
          sweetAlert.payload.data === 'The Connection Fails. Please check your details and retry.' ||
          sweetAlert.payload.data === 'FQDN is already in use.' ||
          sweetAlert.payload.data === 'IPAddress is already in use.'
        ) {
          SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'info', buttonColor: 'blue' });
        } else {
          SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'success', buttonColor: 'green' });
          dispatch(getDomainData());
          navigate('/adminpage');
        }
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoading(false);
    }
  };
  const handleConnectDomain = async (values) => {
    values.domainName = values.domainName.trim();
    values.fqdn = values.fqdn.trim();
    values.username = values.username.trim();
    values.superAdmin = '';
    values.ouAdmin = '';
    values.portalAdmin = '';
    values.distinguishedName = '';
    values.passwordThreshold = parseInt(values.passwordThreshold);
    values.port = parseInt(values.port);
    try {
      setLoading(true);
      const sweetAlert = await dispatch(createDomain(values));
      if (sweetAlert.payload && sweetAlert.payload.status === 200) {
        if (
          sweetAlert.payload.data === 'Domain name is already in use.' ||
          sweetAlert.payload.data === 'The Connection Fails. Please check your details and retry.' ||
          sweetAlert.payload.data === 'FQDN is already in use.' ||
          sweetAlert.payload.data === 'IPAddress is already in use.'
        ) {
          SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'info', buttonColor: 'blue' });
        } else {
          await dispatch(getDropDownGroupData({ ouName: sweetAlert.payload.data.baseDN, fqdn: values.fqdn }));
          await SweetSweetAlert({ sweetData: sweetAlert.payload.data.message, icon: 'success', buttonColor: 'green' });
          setNewDomainId(sweetAlert.payload.data.id);
          setDomainCreated(true);
          setSubmitButtonText('Submit');
          dispatch(getDomainData());
        }
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoading(false);
    }
  };
  const handleSecurityTypeChange = (value) => {
    const newPort = value === 'SSL' ? 636 : 389;
    form.setFieldsValue({ port: newPort });
    if (value === 'Plain') {
      SweetSweetAlert({
        text: `Consider using SSL/TLS as Active Directory doesn’t allow password reset with plain protocol.`,
        icon: 'info',
        buttonColor: 'blue',
      });
    }
  };

  const onCheckboxChange = async (e) => {
    if (e.target.checked) {
      await SweetSweetAlert({
        icon: 'info',
        text: 'Your primary domain may be switched. You will be logged out.!!',
        buttonColor: 'blue',
      });
      setChecked(true);
    } else {
      message.info('Your primary domain will not be switched.');
      setChecked(false);
    }
  };

  return (
    <>
      <Createwrap className='af-outer-wrap af-add_domain-outer-wrap'>
        <CreateStyleDiv className='af-wrap af-add_domain-wrap'>
          {checked ? null : (
            <BackButton to='/adminpage' className='af-back-button af-add_domain-back-button'>
              <LeftArrowIcon className='af-back-button-icon af-add_domain-back-button-icon' /> Back
            </BackButton>
          )}
          <CreateContendwrap className='af-content-wrap af-add_domain-content-wrap'>
            <CreateFormwrap className='af-form-wrap af-add_domain-form-wrap'>
              {loading && <ModalOpenLoader />}
              <FormHeader className='af-form-header af-add_domain-form-header'>Add A Domain</FormHeader>
              <Form
                className='af-form af-add_domain-form'
                form={form}
                layout='vertical'
                name='register'
                onFinish={domainCreated ? handleUpdateDomain : handleConnectDomain}
                scrollToFirstError
                initialValues={{
                  domainName: '',
                  fqdn: '',
                  ipAddress: '',
                  username: '',
                  password: '',
                  superAdmin: '',
                  ouAdmin: '',
                  securityType: 'SSL',
                  port: 636,
                  portalAdmin: '',
                  isPrimaryDomain: false,
                  passwordThreshold: 42,
                }}
                size='large'
              >
                <RowWrapper className='af-form-row-wraper af-add_domain-form-row-wraper af-add_domain-form-row-wraper-wrap1'>
                  <FormItem
                    className='af-form-item af-add_domain-form-item af-add_domain-form-item-domain_name'
                    key='domainName'
                    name='domainName'
                    label='Domain Name'
                    rules={[
                      {
                        required: true,
                        message: `Please Enter the Domain Name`,
                      },
                      {
                        pattern: InputPatternRule.pattern,
                        message: InputPatternRule.message,
                      },
                    ]}
                  >
                    <Input className='af-form-input af-add_domain-form-input af-add_domain-form-input_domain_name' />
                  </FormItem>
                  <FormItem
                    key='fqdn'
                    name='fqdn'
                    label='FQDN'
                    rules={[
                      {
                        required: true,
                        message: `Please Enter the FQDN`,
                      },
                      {
                        pattern: InputPatternRule.pattern,
                        message: InputPatternRule.message,
                      },
                    ]}
                    className='af-form-item af-add_domain-form-item af-add_domain-form-item-fqdn'
                  >
                    <Input className='af-form-input af-add_domain-form-input af-add_domain-form-input_fqdn' />
                  </FormItem>
                </RowWrapper>
                <RowWrapper className='af-form-row-wraper af-add_domain-form-row-wraper af-add_domain-form-row-wraper-wrap2'>
                  <FormItem
                    key='ipAddress'
                    name='ipAddress'
                    label='Server Name/IP'
                    rules={[
                      {
                        required: true,
                        message: `Please Enter the Server Name/IP`,
                      },
                    ]}
                    className='af-form-item af-add_domain-form-item af-add_domain-form-item-ip_address'
                  >
                    <Input className='af-form-input af-add_domain-form-input af-add_domain-form-input_ip_address' />
                  </FormItem>

                  <FormItem
                    key='username'
                    name='username'
                    label='Admin User (DN)'
                    rules={[
                      {
                        required: true,
                        message: `Please Enter the Admin User (DN)`,
                      },
                      {
                        pattern: InputPatternRuleDomainAdminDn.pattern,
                        message: InputPatternRuleDomainAdminDn.message,
                      },
                    ]}
                    className='af-form-item af-add_domain-form-item af-add_domain-form-item-username'
                  >
                    <Input className='af-form-input af-add_domain-form-input af-add_domain-form-input_username' />
                  </FormItem>
                </RowWrapper>
                <RowWrapper className='af-form-row-wraper af-add_domain-form-row-wraper af-add_domain-form-row-wraper-wrap3'>
                  <FormItem
                    key='password'
                    name='password'
                    label='Password'
                    rules={[
                      {
                        required: true,
                        message: `Please Enter the Password`,
                      },
                    ]}
                    className='af-form-item af-add_domain-form-item af-add_domain-form-item-password'
                  >
                    <Input.Password
                      visibilityToggle={false}
                      className='af-form-input af-add_domain-form-input af-add_domain-form-input_password'
                    />
                  </FormItem>
                  <FormItem
                    key='confirmPassword'
                    name='confirmPassword'
                    label='Confirm Password'
                    dependencies={['password']}
                    rules={[
                      {
                        required: true,
                        message: `Please Enter the Confirm Password`,
                      },
                      {
                        validator: validatePasswordMatch,
                      },
                    ]}
                    className='af-form-item af-add_domain-form-item af-add_domain-form-item-cnfrm_password'
                  >
                    <Input.Password
                      visibilityToggle={false}
                      className='af-form-input af-add_domain-form-input af-add_domain-form-input_cnfrm_password'
                    />
                  </FormItem>
                </RowWrapper>
                <RowWrapper className='af-form-row-wraper af-add_domain-form-row-wraper af-add_domain-form-row-wraper-wrap4'>
                  <FormItem
                    key='securityType'
                    name='securityType'
                    label='Security Type'
                    className='af-form-item af-add_domain-form-item af-add_domain-form-item-security_type'
                  >
                    <Select
                      showSearch
                      placeholder='Select'
                      defaultValue='SSL'
                      onChange={handleSecurityTypeChange}
                      className='af-form-select af-add_domain-form-select af-add_domain-form-select_security_type'
                    >
                      <Select.Option className='af-form-select-option af-add_domain-form-select-option' value='Plain'>
                        Plain
                      </Select.Option>
                      <Select.Option className='af-form-select-option af-add_domain-form-select-option' value='SSL'>
                        SSL
                      </Select.Option>
                      <Select.Option className='af-form-select-option af-add_domain-form-select-option' value='TLS'>
                        TLS
                      </Select.Option>
                    </Select>
                  </FormItem>
                  <FormItem
                    key='port'
                    name='port'
                    label='Port'
                    className='af-form-item af-add_domain-form-item af-add_domain-form-item-port'
                  >
                    <Input
                      type='number'
                      className='af-form-input af-add_domain-form-input af-add_domain-form-input_port'
                    />
                  </FormItem>
                </RowWrapper>
                <RowWrapper className='af-form-row-wraper af-add_domain-form-row-wraper af-add_domain-form-row-wraper-wrap5'>
                  <div
                    className='add_domain-form-input_password_threshold-wrapper'
                    style={{ width: '100%', marginBottom: 24 }}
                  >
                    <FormItem
                      key='threshold'
                      name='passwordThreshold'
                      label='Maximum Password Age'
                      className={`${
                        domainCreated ? '' : 'oddFormItem'
                      } af-form-item af-add_domain-form-item af-add_domain-form-item-password_threshold`}
                      rules={[
                        {
                          required: true,
                          message: 'Please Enter the Threshold',
                        },
                      ]}
                      style={{ marginBottom: 0 }}
                    >
                      <Input
                        type='number'
                        className='af-form-input af-add_domain-form-input af-add_domain-form-input_password_threshold'
                      />
                    </FormItem>
                    <FigCaption className='add_domain-caption add_domain-caption-threshold'>
                      **Configure as per your AD group policy
                    </FigCaption>
                  </div>

                  {domainCreated && (
                    <FormItem
                      key='portalAdmin'
                      name='portalAdmin'
                      label='Domain Admin'
                      className='af-form-item af-add_domain-form-item af-add_domain-form-item-portal_admin'
                    >
                      <Select
                        showSearch
                        placeholder='Select the Domain Admin Group'
                        allowClear
                        className='af-form-select af-add_domain-form-select af-add_domain-form-select_portal_admin'
                      >
                        {dropDownGroupData.map((group) => (
                          <Select.Option
                            className='af-form-select-option af-add_domain-form-select-option'
                            key={group.distinguishedName}
                            value={group.distinguishedName}
                          >
                            {group.groupName}
                          </Select.Option>
                        ))}
                      </Select>
                    </FormItem>
                  )}
                </RowWrapper>
                {domainCreated && (
                  <>
                    <RowWrapper className='af-form-row-wraper af-add_domain-form-row-wraper af-add_domain-form-row-wraper-wrap6'>
                      <FormItem
                        key='ouAdmin'
                        name='ouAdmin'
                        label='Ou Admin'
                        className='af-form-item af-add_domain-form-item af-add_domain-form-item-ouadmin'
                      >
                        <Select
                          showSearch
                          placeholder='Select the OuAdmin Group'
                          allowClear
                          className='af-form-select af-add_domain-form-select af-add_domain-form-select_ouadmin'
                        >
                          {dropDownGroupData.map((group) => (
                            <Select.Option
                              className='af-form-select-option af-add_domain-form-select-option'
                              key={group.distinguishedName}
                              value={group.distinguishedName}
                            >
                              {group.groupName}
                            </Select.Option>
                          ))}
                        </Select>
                      </FormItem>
                      <FormItem
                        className='af-form-item af-add_domain-form-item af-add_domain-form-item-is_primary_domain'
                        valuePropName='checked'
                        key='isPrimaryDomain'
                        name='isPrimaryDomain'
                        label='Primary Domain'
                      >
                        <CheckboxWrap className='af-checkbox-wrap af-add_domain-checkbox-wrap'>
                          <div>
                            <Checkbox onChange={onCheckboxChange} />
                            <span style={{ marginLeft: '8px' }}> Mark as Primary </span>
                          </div>
                          <FigCaption className='add_domain-caption add_domain-caption-is_primary_domain'>
                            * Clicking on this checkbox makes the Domain as Primary domain *
                          </FigCaption>
                        </CheckboxWrap>
                      </FormItem>
                    </RowWrapper>
                    <RowWrapper className='af-form-row-wraper af-add_domain-form-row-wraper af-add_domain-form-row-wraper-wrap7'>
                      {checked && (
                        <FormItem
                          className='oddFormItem af-form-item af-add_domain-form-item af-add_domain-form-item-super_admin'
                          key='superAdmin'
                          name='superAdmin'
                          label='Super Admin'
                          rules={[
                            {
                              required: true,
                              message: `Please Enter the Super Admin`,
                            },
                          ]}
                        >
                          <Select
                            showSearch
                            placeholder='Select the SuperAdmin Group'
                            allowClear
                            className='af-form-select af-add_domain-form-select af-add_domain-form-select_super_admin'
                          >
                            {dropDownGroupData.map((group) => (
                              <Select.Option
                                className='af-form-select-option af-add_domain-form-select-option'
                                key={group.distinguishedName}
                                value={group.distinguishedName}
                              >
                                {group.groupName}
                              </Select.Option>
                            ))}
                          </Select>
                        </FormItem>
                      )}
                    </RowWrapper>
                  </>
                )}
                <FormSubmitButtonConatainer className='af-form-button-submit-wrapper af-add_domain-form-button-submit-wrapper'>
                  <StyledButton
                    type='primary'
                    htmlType='submit'
                    disabled={!passwordMatch}
                    className='af-form-button af-add_domain-form-button af-add_domain-form-button_submit'
                  >
                    {submitButtonText}
                  </StyledButton>
                </FormSubmitButtonConatainer>
              </Form>
            </CreateFormwrap>
          </CreateContendwrap>
        </CreateStyleDiv>
      </Createwrap>
    </>
  );
}

export default CreateDomain;
